
import {
    Button,
    TableCell,
    TableRow,
    Box,
    Typography,
    Table,
    TableHead,
    TableBody,
    Collapse,
    IconButton
} from "@material-ui/core"
import moment from "moment/moment";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import { memo, useState } from "react";
import { ESTADOS_COTIZACIONES } from "../../../utils/constants";
import { PracticaItem } from "../../autorizaciones/gestionAuditoria/PracticaItem";
import { ModalCargarCotizacion } from "./ModalCargarCotizacion";
import { useDispatch } from "react-redux";
import { enviarCotizacion, enviarMailAceptacionCotizacion } from "../../../actions/compras/Cotizaciones";
import { ModalAceptarCotizacion } from "./ModalAceptarCotizacion";
import IconEstado from "../../autorizaciones/UI/IconEstado";
import { ModalMostrarDatosCotizacionAceptada } from "./ModalMostrarDatosCotizacionAceptada";
import { ModalHistorialCambiosCotizaciones } from "../TrackingCotizaciones/ModalHistorialCambiosCotizaciones";
import InfoHistorialIcon from "../../autorizaciones/UI/InfoHistorialIcon";
import ModalAnularSolicitud from "./ModalAnularSolicitud";

export const CotizacionesItem = memo((props) => {
    const { item, estadoSolicitud, cotizaciones, estadosCotizacion, idTipoSolicitud } = props;
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const [openModalCargarCotizacion, setOpenModalCargarCotizacion] = useState(false);
    const [openModalAceptarCotizacion, setOpenModalAceptarCotizacion] = useState(false);
    const [openModalMostrarDatosCotizacionAceptada, setOpenModalMostrarDatos] = useState(false);
    const [openModalHistorialCambios, setOpenModalHistorialCambios] = useState(false);
    const [openModalAnularSolicitud, setOpenModalAnularSolicitud] = useState(false);
    const [disabledAnulacion, setDisabledAnulacion] = useState(false);

    const SendEmail = () => {
        cotizaciones.cabeceraCotizacion.map((a) => (
            dispatch(enviarMailAceptacionCotizacion(item.idSolicitud, a.idOferente))
        ))
    }
    debugger
    console.log(cotizaciones)
    return (
        <>
            {
                openModalCargarCotizacion && (
                    <ModalCargarCotizacion
                        open={openModalCargarCotizacion}
                        closeModalHandler={() => {
                            setOpenModalCargarCotizacion(false);
                        }}
                        cabeceraCotizacion={cotizaciones.cabeceraCotizacion}
                        idSolicitud={item.idSolicitud}
                        idEstado={estadoSolicitud}
                        cotizacion={cotizaciones}
                        idTipoSolicitud={idTipoSolicitud}
                    />
                )
            }
            {
                openModalAceptarCotizacion && (
                    <ModalAceptarCotizacion
                        open={openModalAceptarCotizacion}
                        closeModalHandler={() => { setOpenModalAceptarCotizacion(false) }}
                        cabeceraCotizacion={cotizaciones.cabeceraCotizacion}
                        idSolicitud={item.idSolicitud}
                        idEstado={estadoSolicitud}
                        idTipoSolicitud={idTipoSolicitud}
                    />
                )
            }
            {
                openModalMostrarDatosCotizacionAceptada &&
                <ModalMostrarDatosCotizacionAceptada
                    open={openModalMostrarDatosCotizacionAceptada}
                    closeModalHandler={() => { setOpenModalMostrarDatos(false) }}
                    cotizacion={cotizaciones}
                    idSolicitud={item.idSolicitud}
                    idEstado={estadoSolicitud}
                />
            }
            {
                openModalHistorialCambios &&
                <ModalHistorialCambiosCotizaciones
                    open={openModalHistorialCambios}
                    closeModalHandler={() => { setOpenModalHistorialCambios(false) }}
                    idSolicitud={item.idSolicitud}
                />
            }
            {
                openModalAnularSolicitud &&
                <ModalAnularSolicitud
                    open={openModalAnularSolicitud}
                    handleClose={() => { setOpenModalAnularSolicitud(false) }}
                    idCotizacion={cotizaciones.idCotizacion}
                    idTipoSolicitud={idTipoSolicitud}
                    disabled={disabledAnulacion}
                    msj={cotizaciones.motivoBaja}
                />
            }
            <TableRow>
                <TableCell align="center" sx={{ padding: "10px" }}>
                    <InfoHistorialIcon onClick={() => setOpenModalHistorialCambios(true)} />
                </TableCell>
                <TableCell>
                    {
                        cotizaciones.urgente && (
                            <IconEstado
                                texto={"U"}
                                useColorTable={true}
                                descripcion={'Urgente'}
                                extraMarginRight={true}
                                backgroundColor={"red"}
                            />
                        )
                    }
                    {estadosCotizacion &&
                        estadosCotizacion.map((estado) => (

                            Number(estado.idEstado) === Number(estadoSolicitud)
                            && (
                                <IconEstado
                                    useColorTable={true}
                                    texto={estado.letra}
                                    backgroundColor={estado.color}
                                    descripcion={estado.descripcionEstado}
                                />

                            )
                        ))}

                </TableCell>
                {
                    Number(estadoSolicitud) === ESTADOS_COTIZACIONES.COTIZACIONES_SOLICITADAS && (
                        <>
                            <TableCell>{moment(cotizaciones.fechaSolicitud).format("DD/MM/YYYY")}</TableCell>
                            <TableCell>{item.idSolicitud}</TableCell>
                            <TableCell>{item.tipoSolicitud.descripcionTipo}</TableCell>
                            <TableCell>{item.fechaProgramada ? moment(item.fechaProgramada).format("DD/MM/YYYY") : ""}</TableCell>
                            <TableCell>{item.tipoSolicitud.requiereFechaProgramada === true ? 'SI' : 'NO'}</TableCell>
                            <TableCell>{item.afiliado.apellido_y_nombre}</TableCell>
                            <TableCell></TableCell>
                            <TableCell> {item.practicas.map((cp) => {
                                if (cp.cartillaPrestadores) {
                                    return cp.cartillaPrestadores?.prestador?.nombreApellido
                                }
                                return null
                            })
                            }</TableCell>
                            <TableCell style={{ textAlign: 'center' }}>
                                {item.practicas.length > 0 && (
                                    <IconButton
                                        aria-label="expand row"
                                        size="small"
                                        onClick={() => setOpen(!open)}
                                    >
                                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                    </IconButton>
                                )}
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={() => setOpenModalAnularSolicitud(true)}
                                >
                                    Anular Solicitud
                                </Button>
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={() => setOpenModalCargarCotizacion(true)}
                                >
                                    Cargar Cotizacion
                                </Button>
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => dispatch(enviarCotizacion({ DatosCotizacion: cotizaciones.cabeceraCotizacion }, Number(estadoSolicitud), idTipoSolicitud))}
                                >
                                    Enviar Aud.Compras
                                </Button>
                            </TableCell>

                        </>
                    )}
                {
                    Number(estadoSolicitud) === ESTADOS_COTIZACIONES.PENDIENTE_ACEPTACION && (
                        <>
                            <TableCell>{item.idSolicitud}</TableCell>
                            <TableCell>{moment(cotizaciones.fechaEnvio).format("DD/MM/YYYY")}</TableCell>
                            <TableCell>{item.afiliado.apellido_y_nombre}</TableCell>
                            <TableCell>{item.afiliado.carnet}</TableCell>
                            <TableCell>{item.diagnostico?.problema}</TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => setOpenModalAceptarCotizacion(true)}>
                                    Ver Cotizacion
                                </Button>
                            </TableCell>
                            <TableCell>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    onClick={() => setOpenModalAnularSolicitud(true)}
                                >
                                    Anular Solicitud
                                </Button>
                            </TableCell>
                        </>
                    )
                }
                {
                    Number(estadoSolicitud) === ESTADOS_COTIZACIONES.ANULADAS && (
                        <>
                            <TableCell>{moment(cotizaciones.fechaSolicitud).format("DD/MM/YYYY")}</TableCell>
                            <TableCell>{item.idSolicitud}</TableCell>
                            <TableCell>{item.tipoSolicitud.descripcionTipo}</TableCell>
                            <TableCell>{item.fechaProgramada ? moment(item.fechaProgramada).format("DD/MM/YYYY") : ""}</TableCell>
                            <TableCell>{item.tipoSolicitud.requiereFechaProgramada === true ? 'SI' : 'NO'}</TableCell>
                            <TableCell>{item.afiliado.apellido_y_nombre}</TableCell>
                            <TableCell></TableCell>
                            <TableCell> {item.practicas.map((cp) => {
                                if (cp.cartillaPrestadores) {
                                    return cp.cartillaPrestadores?.prestador?.nombreApellido
                                }
                                return null
                            })}
                            </TableCell>
                            <TableCell></TableCell>
                            <TableCell>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={() => {
                                        setOpenModalAnularSolicitud(true)
                                        setDisabledAnulacion(true)
                                    }}>
                                    Ver Motivo Baja
                                </Button>
                            </TableCell>
                        </>
                    )
                }
                {Number(estadoSolicitud) === ESTADOS_COTIZACIONES.COTIZACIONES_ACEPTADAS && (
                    <>
                        <TableCell>{item.idSolicitud}</TableCell>
                        <TableCell>{
                            moment(cotizaciones.fechaCotizacion).format("DD/MM/yyyy")
                        }
                        </TableCell>
                        <TableCell>{item.afiliado.apellido_y_nombre}</TableCell>
                        <TableCell>{item.afiliado.carnet}</TableCell>
                        <TableCell>{item.fechaProgramada ? moment(item.fechaProgramada).format("DD/MM/YYYY") : ""}</TableCell>
                        <TableCell>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={() => setOpenModalMostrarDatos(true)}
                            >
                                Ver Detalle
                            </Button>
                        </TableCell>
                        <TableCell>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={() => { SendEmail() }}
                            >
                                Re-Enviar Mail
                            </Button>
                        </TableCell>
                        <TableCell>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={() => setOpenModalAnularSolicitud(true)}
                            >
                                Anular Solicitud
                            </Button>
                        </TableCell>
                    </>
                )}
            </TableRow>
            <TableRow>
                <TableCell
                    style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 100 }}
                    colSpan={11}
                >
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box margin={1}>
                            <Typography variant="h6" gutterBottom component="div">
                                Practicas
                            </Typography>
                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Estado Práctica</TableCell>
                                        <TableCell>Práctica</TableCell>
                                        <TableCell align="right">Cantidad</TableCell>
                                        <TableCell align="center">SURGE</TableCell>
                                        <TableCell>Materiales</TableCell>
                                        <TableCell>Institucion</TableCell>
                                        {(item.conInternacion || item.idPrestacion) &&
                                            <TableCell>Profesional</TableCell>
                                        }
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {item.practicas.map((practica) => (
                                        <PracticaItem
                                            key={practica?.idCodNom?.toString()}
                                            conInternacion={practica.conInternacion}
                                            idPrestacion={item.idPrestacion}
                                            idTipoSolicitud={item?.idTipoSolicitud}
                                            item={practica}
                                        />
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    )
});